import { createSignal, For, onMount, Show } from "solid-js";
import { cleanImagePath, toQueryString } from "../api";
import { PageList } from "../components/page-list";

type Mode = "All" | "OnlyBySelectedArtworkLocation";

type DepictedArtworkJson = {
    Title: string;
    Artist: string;
    DateRange: string;
    ArtworkId: number;
    ArtistId: number;
    PrimaryImageUrl: string;
};
type Props = {
    latitude: number;
    longitude: number;
    name: string;
    colour: string;
}
export function DepictedPlaceInfoWindow (props: Props) {
    const [artworks, setArtworks] = createSignal<any[]>([]);
    const [mode, setMode] = createSignal<Mode>("OnlyBySelectedArtworkLocation");
    const [page, setPage] = createSignal<number>(1);
    const [showBlockTextForArtworkId, setShowBlockTextForArtworkId] = createSignal<number|null>(null);
    const [maxPage, setMaxPage] = createSignal<number>(1);
    const [count, setCount] = createSignal<number>(0);
    const toggleMode = async (e: Event) => {
        e.preventDefault();
        if (mode() == "All") {
            setMode("OnlyBySelectedArtworkLocation");
        } else {
            setMode("All");
        }
        await search();
    };
    const [blockSize, setBlockSize] = createSignal<number>(10);
    const loadPage = async (page: number) => {
        setPage(page);
        await search();
    };
    const search = async () => {
        const model = toQueryString({
            latitude: props.latitude,
            longitude: props.longitude,
            page: page(),
            pageRows: 10
        });
        const response = await fetch("/Artwork/SolidGetAllArtworksAtGeolocation?" + model);
        const json = await response.json();
        if (!json.Success) return;
        const data = json.Data;
        setCount(data.Count);
        setPage(data.Page);
        setMaxPage(data.MaxPage);
        setArtworks(data.Results);
        return json;
    };
    onMount(async () => {
        await search();
    });
    return (
    <>
        <div style="text-align: left; color: #333; width: 850px;">
            <h4>
                {props.name}
            </h4>
            <p>
                {count()} artworks
            </p>
            <p>
                {page()} / {maxPage()} pages
            </p>
            <div style="border-top: 1px dotted #ccc; margin-top: 10px; padding-top: 10px;">
                <div>
                    <PageList page={page} blockSize={blockSize} onClick={loadPage} maxPage={maxPage}></PageList>
                </div>
                <Show when={artworks()?.length == 0}>
                    <h3>
                        No artworks found here
                    </h3>
                </Show>
                <Show when={artworks()?.length > 0}>
                    <div class="finalist-grid">
                        <For each={artworks()}>{(x: DepictedArtworkJson) =>
                            <div class="category-image"
                                style={{ "display": "inline-block" }}
                                onMouseOver={(e: Event) => { e.stopPropagation(); setShowBlockTextForArtworkId(x.ArtworkId); }}
                                onMouseLeave={(e: Event) => { e.stopPropagation(); setShowBlockTextForArtworkId(null); }}>
                                <div style={{ "padding": "5px", "background-color": "#333", "text-align": "center", position: "relative" }}>
                                    <a href={ "/Artwork/Index/" + x.ArtworkId } target="_blank">
                                        <img style="width: 150px; height: 150px;" alt={x.Title + " " + x.Artist} src={ cleanImagePath(x.PrimaryImageUrl) + "?mode=crop&format=jpg&width=150&height=150&anchor=topLeft" } />
                                        <Show when={showBlockTextForArtworkId() == x.ArtworkId}>
                                            <div class="gallery-image-overlay" style="width: 150px;">
                                                <p class="title">{x.Title}</p>
                                                <p class="salon">by {x.Artist} <Show when={!!x.DateRange}>[{x.DateRange}]</Show></p>
                                            </div>
                                        </Show>
                                    </a>
                                </div>
                            </div>
                        }</For>
                    </div>
                </Show>
            </div>
        </div>
    </>
  );      
};